$(document).ready(function () {
  "use strict";

  $(".order--container").on("click", function () {
    if ($(this).hasClass("follow__link") == false) {
      var orderId = $(this).attr("order-id");
      $('.order__details[order-id="' + orderId + '"]')
        .slideToggle(200)
        .toggleClass("is-active");
      $(this).toggleClass("child-active");
      $(this)
        .children(".open__line__items--link")
        .children()
        .toggleClass("rotate-180");
    }
  });
  ("use strict");

  $("body").on("click", ".add__to__cart", function (e) {
    e.preventDefault();
    var variantId = $(this).attr("variant-id");
    var available = $(this).attr("variant-available");
    var productHandle = $(this).attr("product-handle");
    var variants = $(this).attr("variants");
    var type = $(this).attr("button-type");
    var ref_product = $(this).attr("ref_produit");
    var ref_couleur = $(this).attr("ref_couleur");
    var ref_code_court = $(this).attr("ref_produit_code_court");
    if (available == "true" || available == true) {
      if (variantId) {
        var qty = 1;
        if (type == "product") {
          qty = $(".product__qty--container .quantity__current").val();
        }
        var objUpdate = {
          quantity: qty,
          id: variantId,
          properties: {
            "Ref produit": ref_product,
            "Ref couleur": ref_couleur,
            "Ref produit (court)": ref_code_court,
          },
        };

        if (
          document.querySelector("textarea") != null &&
          document.querySelector("textarea").value == ""
        ) {
          //ajout
          console.log("champ de personnalisation texte vide"); //ajout
          document.querySelector("textarea").style.borderColor = "red"; //ajout
          return; //ajout
        } //ajout

        if ($(this).hasClass("perso-text")) {
          var text = $(".perso-text").val();
          /*        objUpdate.properties = {
                  "Personnalisation": text
                }*/
          objUpdate.properties["Personnalisation"] = text;
        } else if ($(this).hasClass("perso-image")) {
          var image = $(".uploadkit-attribute-container input").attr("value");

          $(".uploadkit").removeClass("inputRequired"); //ajout
          if (image === void 0) {
            //ajout
            console.log("champ de personnalisation image vide"); //ajout
            $(".uploadkit").addClass("inputRequired"); //ajout
            return; //ajout
          } //ajout
          /*objUpdate.properties = {
          "Uploaded image": image
        }*/
          objUpdate.properties["Uploaded image"] = image;
        } else if ($(this).hasClass("perso-options")) {
          var lineOptions = "";
          for (var i = 1; i < productDetails.numberPersoOptions + 1; i++) {
            var name = $(".select-perso-" + i).attr("name");
            var value = $(".select-perso-" + i).val();
            lineOptions += name + ":" + value + ";";
          }
          /*objUpdate.properties = {
          "Personnalisation options": lineOptions
        }*/
          objUpdate.properties["Personnalisation options"] = lineOptions;
        }

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: objUpdate,
          dataType: "json",
          success: function success(response) {
            updateCartData();
            renderCart();
            document.dispatchEvent(new CustomEvent("update-reco-drawer"));

            if ($("#empty__cart--title").length > 0) {
              location.reload(true);
            }

            document.dispatchEvent(new CustomEvent("cart:open"));
            $(this).children(".button--text").css("display", "block");
            $(this).children(".button--loading").css("display", "none");
          },
          error: function error(_error) {
            console.log("erreur");
            console.log(_error);
          },
        });
      }
    }
  });

  $("body").on("click", ".remove--line-item", function (e) {
    e.preventDefault();
    var $this = $(this);
    var key = $(this).attr("key");

    var data = { updates: {} };
    data.updates[key] = 0;
    setTimeout(function () {
      $('.cart__item--container[key="' + key + '"]').remove();
    }, 300);
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: data,
      dataType: "json",
      success: function success(response) {
        updateCartData();
        renderCart();
        document.dispatchEvent(new CustomEvent("update-reco-drawer"));
      },
      error: function error(_error2) {
        console.log("erreur");
      },
    });
  });

  $("body").on("change", ".qty--input", function (e) {
    e.preventDefault();
    var $this = $(this);
    var variantId = $(this).attr("variant-id");
    var variantQty = $this.val();

    if (variantId) {
      var data = { updates: {} };
      data.updates[variantId] = variantQty;

      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: data,
        dataType: "json",
        success: function success(response) {
          // On render le cart via le module shippinh-module-cart.js
          updateCartData();
        },
        error: function error(_error3) {
          console.log("erreur");
        },
      });
    }
  });

  const updateCartItems = () => {
    $.ajax({
      type: "GET",
      url: "https://" + window.location.hostname + "/?section_id=cart-drawer",
      success: function success(data) {
        const dom = $(data);
        const cartDrawerBody = dom.find(".cart__drawer--body");
        $(".cart__drawer--body").html(cartDrawerBody);
      },
      error: function error(_error) {
        console.log("erreur");
        console.log(_error);
      },
    });
  };

  var updateCartData = function updateCartData() {
    $.ajax({
      type: "GET",
      url: "/cart",
      dataType: "json",
      success: function success(response) {
        var total = response.total_price;
        var empty = response.item_count == 0 ? true : false;
        updateDeliveryModule(total);
        if (empty) {
          $(".cart--body").addClass(
            "flex flex-col justify-center items-center",
          );
          $(".total-drawer--container").addClass("hidden");
          $(".empty__cart--drawer").removeClass("hidden");
          $(".items--count").text(0);

          if ($("#full__cart--title").length > 0) {
            location.reload(true);
          }
        } else {
          $(".cart--body").removeClass(
            "flex flex-col justify-center items-center",
          );
          $(".total-drawer--container").removeClass("hidden");
          $(".empty__cart--drawer").addClass("hidden");

          updateCartItems();
          $(".cart__total--drawer").text(displayPrice(total));

          $(".items--count").text(response.item_count);
        }
      },
      error: function error(_error4) {
        console.log("erreur");
      },
    });
  };

  var renderCart = function renderCart() {
    var url = "/cart?view=sidecart&timestamp=" + Date.now();

    if (window.location.href.indexOf("/cart") > -1) {
      url = "/cart?view=page&timestamp=" + Date.now();
    }

    $.ajax({
      type: "GET",
      url: url,
      success: function success(content) {
        var newCart = content;
        $(".cart__items__and__header--container").remove();
        $(".cart--body").append(newCart);

        if (window.location.href.indexOf("/cart") > -1) {
          $("#cart--title, .side-bar-cart").remove();
          $(".form-cart")
            .removeClass(
              "grid-cols-[calc(75%-20px)_calc(25%-20px)] gap-x-[40px]",
            )
            .addClass("grid-cols-1");
        }
      },
      error: function error(_error5) {
        console.log(_error5);
        console.log("erreur");
      },
    });
  };

  document.addEventListener(
    "cart:open",
    function (elem) {
      $("#cart__drawer").addClass("opened");
      $("#page__overlay").addClass("opened").attr("for", "drawer");
      setTimeout(function () {
        $("#drawer__cart--exta-infos").addClass("opened");
      }, 350);
    },
    false,
  );
  ("use strict");

  if (window.cart) {
    var deliveryModuleWidth = 100;
    var renderFirst = 0;

    var nbSteps = window.cart.nbSteps;
    if (nbSteps > 1 && nbSteps < 3) {
      deliveryModuleWidth = 33.33;
    } else if (nbSteps > 2) {
      deliveryModuleWidth = 25;
    }
    var ajaxCartProducts = function ajaxCartProducts(qty1) {
      var objUpdate = { updates: {} };
      objUpdate.updates[44816234283284] = qty1;

      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: objUpdate,
        dataType: "json",
        success: function success(response) {
          renderCart();
        },
        error: function error(_error) {
          console.log(_error);
        },
      });
    };

    var shippingBarLogic = function shippingBarLogic(total) {
      var currentStep = 1;
      if (total >= window.cart.steps[0] && total < window.cart.steps[1]) {
        currentStep = 2;
      } else if (total >= window.cart.steps[1]) {
        currentStep = 3;
      }

      var remainMoney = 0;
      var remainPercentage = 0;
      var colorBar = 0;

      var barCalculus = function barCalculus(step, total) {
        var seuilSuivant = window.cart.steps[step - 1];
        var seuilPrecedent = 0;
        if (step != 1) {
          seuilPrecedent = window.cart.steps[step - 2];
        }

        remainMoney = Math.max(0, (seuilSuivant - total) / 100);
        remainPercentage = Math.max(
          0,
          (seuilSuivant - total) / (seuilSuivant - seuilPrecedent),
        );
        colorBar =
          deliveryModuleWidth * step - deliveryModuleWidth * remainPercentage;
      };

      var finalStep = function finalStep() {
        remainMoney = 0;
        remainPercentage = 0;
        colorBar = 100;
      };

      switch (currentStep) {
        case 1:
          barCalculus(1, total);
          break;
        case 2:
          barCalculus(2, total);
          break;
        case 3:
          barCalculus(3, total);
          break;
        default:
          break;
      }

      if (currentStep == 1) {
        ajaxCartProducts(0);
      } else if (currentStep == 2 && nbSteps > 1) {
        if (nbSteps == 1) {
          finalStep();
        } else {
          if (window.cart.deliveryStep == 1) {
            ajaxCartProducts(0);
          } else {
            ajaxCartProducts(1);
          }
        }
      } else {
        finalStep();
        if (window.cart.deliveryStep == 0 && nbSteps == 2) {
          ajaxCartProducts(1);
        } else if (window.cart.deliveryStep == 0 && nbSteps == 1) {
          ajaxCartProducts(1);
        } else if (
          (window.cart.deliveryStep == 1 || window.cart.deliveryStep == 2) &&
          nbSteps == 2
        ) {
          ajaxCartProducts(1);
        } else {
          ajaxCartProducts(0);
        }
      }

      $("#progress__bar--remain").css("width", colorBar + "%");

      if (remainMoney > 0) {
        var moinsDix = remainMoney < 10 ? true : false;
        remainMoney = remainMoney.toString().replace(".", ",");
        if (moinsDix == true && remainMoney.length == 3) {
          remainMoney = remainMoney + "0";
        } else if (moinsDix == false && remainMoney.length == 4) {
          remainMoney = remainMoney + "0";
        }

        $("#free__shipping--message").hide();
        $("#remain__shipping__amount--message").show();
        $("#amount__remaining").text(remainMoney + "€");
      } else {
        $("#free__shipping--message").show();
        $("#remain__shipping__amount--message").hide();
      }
    };

    var getCartTotal = function getCartTotal(callback, cart) {
      if (cart) {
        if (callback) {
          callback(cart.total_price);
        } else {
          return cart.total_price;
        }
      } else {
        $.ajax({
          type: "GET",
          url: "/cart.js",
          dataType: "json",
          success: function success(cart) {
            if (callback) {
              callback(cart.total_price);
            } else {
              return cart.total_price;
            }
          },
        });
      }
    };

    var initializeDeliveryModule = function initializeDeliveryModule() {
      var total = getCartTotal(shippingBarLogic);
    };

    setTimeout(function () {
      initializeDeliveryModule();
    }, 1000);

    var updateDeliveryModule = function updateDeliveryModule(total) {
      if (window.cart.deliveryModule) {
        if (total) {
          shippingBarLogic(total);
        } else {
          getCartTotal(shippingBarLogic);
        }
      }
    };
  }
  ("use strict");

  document.addEventListener(
    "update-reco-drawer",
    function (e) {
      $.ajax({
        type: "GET",
        url:
          "https://" + window.location.hostname + "/?section_id=reco-lateral",
        success: function success(data) {
          $("#product-reco--container").empty().append(data);
        },
        error: function error(_error) {
          console.log("erreur");
          console.log(_error);
        },
      });
    },
    false,
  );
  ("use strict");

  if (window.collection) {
    var selectedInput = $(
      '.select__custom--value[value="' + window.collection.defaultSortBy + '"]',
    )
      .first()
      .text();

    //$('.select__custom--value[value="' + window.collection.defaultSortBy + '"]').addClass('bg-primary');

    $(".select__custom--selected-value").text(selectedInput);
  }
  ("use strict");

  if (
    window.location.href.indexOf("collections/") > -1 &&
    window.general.collection
  ) {
    var printUrl = function printUrl(list) {
      var filteredUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.collection.collectionUrl +
        "?";
      for (var filter in list) {
        filteredUrl += list[filter].type + "=" + list[filter].value + "&";
      }

      var sortBy = $(
        "#sort__by--container .select__custom--value.is__active",
      ).attr("value");
      var filterSortBy = "sort_by=" + sortBy;

      var pageUrl = "";
      /*if (window.location.href.indexOf('page=') > -1){
      var url_string = window.location.href
      var url = new URL(url_string);
      var numberPage = url.searchParams.get("page");
      pageUrl = "&page=" + numberPage
    }*/

      var finalUrl = filteredUrl + filterSortBy + pageUrl;

      if (history.replaceState) {
        window.history.replaceState({ path: finalUrl }, "", finalUrl);
      }

      $.ajax({
        type: "GET",
        url: finalUrl + "&view=filtered",
        success: function success(content) {
          var count = parseInt(content.substring(0, 4));
          $(".filter-count").text(count);
          $("#collection__list--container").remove();
          $("#collection__page--desktop").append(content.substring(4));

          clearFilter();
        },
        error: function error(_error2) {
          console.log("erreur");
        },
      });
    };

    // Filters
    $("body").on("click", ".reinitialize__filters", function () {
      window.collection.currentFilters = [];
      //$('.reinitialize__filters').hide()
      $(".filter__button").removeClass("is__active");
      var filteredUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.collection.collectionUrl +
        "?sort_by=" +
        window.collection.sortBy;
      if (history.replaceState) {
        window.history.replaceState({ path: filteredUrl }, "", filteredUrl);
      }
      $(".filter--container").removeClass("checked");
      $(".filter--container .checkbox-filter--container").removeClass(
        "checked",
      );
      $.ajax({
        type: "GET",
        url: filteredUrl + "&view=filtered",
        success: function success(content) {
          var count = parseInt(content.substring(0, 4));
          $(".filter-count").text(count);
          $("#collection__list--container").remove();
          $("#collection__page--desktop").append(content.substring(4));
        },
        error: function error(_error) {
          console.log("erreur");
        },
      });
    });

    var collectionFilter = {};
    if ($("[collection-filter]").html()) {
      collectionFilter = JSON.parse($("[collection-filter]").html());
    }

    //Range slider price
    var $range = $(".js-range-slider"),
      $from = $(".from"),
      $to = $(".to"),
      range,
      min = $range.data("min"),
      max = $range.data("max"),
      from,
      to;

    var updateValues = function updateValues() {
      $from.prop("value", from);
      $to.prop("value", to);

      dataFilter = boucleFilter();
      console.log(dataFilter);
      printUrl(dataFilter);
    };

    var updateFilter = function updateFilter() {
      var maxRange = collectionFilter.filterMaxRange / 100;
      if (from == "0" && to == maxRange) {
        $('.active-filters__remove-filter[filtername="filter-price"]').hide();
      } else {
        $('.active-filters__remove-filter[filtername="filter-price"]').show();
        $(".min-value-filter").text(from + "€");
        $(".max-value-filter").text(to + "€");
      }
    };

    $range.ionRangeSlider({
      onChange: function onChange(data) {
        from = data.from;
        to = data.to;
        console.log(to);
        updateValues();
        updateFilter();
        $(".irs-from, .irs-to").append(" €");
      },
    });

    $(window).bind("load", function () {
      $(".irs-from, .irs-to").append(" €");
    });

    range = $range.data("ionRangeSlider");
    var updateRange = function updateRange() {
      range.update({
        from: from,
        to: to,
      });
    };

    $from.on("input", function () {
      from = +$(this).prop("value");
      if (from < min) {
        from = min;
      }
      if (from > to) {
        from = to;
      }
      updateValues();
      updateRange();
      updateFilter();
    });

    $to.on("input", function () {
      to = +$(this).prop("value");
      if (to > max) {
        to = max;
      }
      if (to < from) {
        to = from;
      }
      updateValues();
      updateRange();
      updateFilter();
    });

    $(document).ready(function () {
      if (collectionFilter.filterMaxValue != "") {
        to = collectionFilter.filterMaxValue / 100;
      }
      if (collectionFilter.filterMinValue != "") {
        from = collectionFilter.filterMinValue / 100;
      }
      updateRange();
    });

    var clearFilter = function clearFilter() {
      var url = window.location.href;
      var matches = url.match(/[a-z\d]+=[a-z\d]+/gi);
      var count = matches ? matches.length : 0;
      if (window.location.search.indexOf("page=") > -1) {
        count = count - 1;
      }
    };

    $(document).ready(function () {
      clearFilter();
    });

    var dataFilter = [];

    var boucleFilter = function boucleFilter() {
      var array = [];
      $(".filter-group-display__list").each(function () {
        var containerFilter = $(this).children(
          ".filter-group-display__list-item",
        );

        var checkbox = containerFilter
          .children(".filter--container")
          .children(".checkbox-filter--container");
        var value = "";
        var name = checkbox.attr("name");
        var compteurCheck = 0;
        for (var i = 1; i <= containerFilter.length; i++) {
          var loopCheckbox = containerFilter
            .children(".filter--container")
            .children(".checkbox-" + i);

          if (loopCheckbox.hasClass("checked")) {
            if (name == "filter.v.option.taille") {
              array.push({ type: "filter.v.availability", value: 1 });
            }

            compteurCheck += 1;

            compteurCheck == 1
              ? (value = loopCheckbox.attr("value"))
              : (value = value + "," + loopCheckbox.attr("value"));
          }
        }
        compteurCheck > 0 ? array.push({ type: name, value: value }) : null;
      });

      var nameFilterLow = $("#lowPriceFilter").attr("name");
      var valueLow = $("#lowPriceFilter").val();

      var nameFilterHigh = $("#highPriceFilter").attr("name");
      var valueHigh = $("#highPriceFilter").val();
      var maxValueHigh = $("#highPriceFilter").attr("max");

      if (parseInt(valueLow) > 0) {
        array.push({ type: nameFilterLow, value: valueLow });
      }

      if (parseInt(valueHigh) <= parseInt(maxValueHigh)) {
        console.log("passe max value");
        array.push({ type: nameFilterHigh, value: valueHigh });
      }

      return array;
    };

    if (window.location.href.indexOf("collections") > -1) {
      dataFilter = boucleFilter();

      console.log("Chargement");
      console.log(dataFilter);
      console.log("Chargement");
    }

    $("body").on("click", ".filter--container", function () {
      var filterTaille = $(this)
        .find(".checkbox-filter--container")
        .attr("name");
      if ($(this).find(".checkbox-filter--container").hasClass("checked")) {
        var filterName = $(this)
          .find(".checkbox-filter--container")
          .attr("filtername");
        //$(`.active-filters__remove-filter[filtername=${filterName}]`).remove()
      } else {
        var filterName = $(this)
          .find(".checkbox-filter--container")
          .attr("filtername");

        if (filterName == "Disponibilité-Enstock") {
          var filterValue = "En stock";
        } else if (filterTaille == "filter.v.option.taille") {
          console.log("Taille click");
          $(".taille--container").removeClass("checked");
          $(".taille--container")
            .children(".checkbox-filter--container")
            .removeClass("checked");
        } else {
          var filterValue = $(this)
            .find(".checkbox-filter--container")
            .attr("value");
        }
        $(".active-filters").append(
          '\n        <a class="active-filters__remove-filter cursor--pointer" filtername="' +
            filterName +
            '">\n            ' +
            filterValue +
            " X\n        </a>\n      ",
        );
      }

      var checkboxContainer = $(this).children(".checkbox-filter--container");
      checkboxContainer.hasClass("checked")
        ? checkboxContainer.removeClass("checked")
        : checkboxContainer.addClass("checked");
      $(this).hasClass("checked")
        ? $(this).removeClass("checked")
        : $(this).addClass("checked");

      dataFilter = boucleFilter();

      console.log(dataFilter);
      printUrl(dataFilter);
    });

    var countEuro = 1;
    $("body").on("click", ".filter-group-summary", function () {
      if ($(this).hasClass("checked")) {
        $(this).removeClass("checked");
        $(this).siblings(".filter-group-display").slideToggle(200);
        $(this).children(".plus__icon").removeClass("opened");
      } else {
        $(this).addClass("checked");
        $(this).siblings(".filter-group-display").slideToggle(200);
        $(this).children(".plus__icon").addClass("opened");

        if ($(this).hasClass("price-click")) {
          setTimeout(function () {
            if (countEuro == 1) {
              console.log("passe euro");
              countEuro = countEuro + 1;
              $(".irs-from, .irs-to").append(" €");
            }
          }, 400);
        }
      }
    });

    $("body").on("click", ".see-more", function () {
      var which = $(this).attr("which");
      $('.see-more[which="' + which + '"]').hide();
      $('.see-less[which="' + which + '"]').show();

      $(
        ".filter-group-display." +
          which +
          "--container .filter-group-display__list",
      ).removeClass("max-h-[335px]");
    });

    $("body").on("click", ".see-less", function () {
      var which = $(this).attr("which");
      $('.see-more[which="' + which + '"]').show();
      $('.see-less[which="' + which + '"]').hide();

      $(
        ".filter-group-display." +
          which +
          "--container .filter-group-display__list",
      ).addClass("max-h-[335px]");
    });

    $("body").on("click", ".active-filters__clear", function () {
      var link = $(this).attr("link");
      $(".filter--container, .checkbox-filter--container").removeClass(
        "checked",
      );
      $("#lowPriceFilter").attr("value", 0);
      var maxRangeValue = collectionFilter.filterMaxRange / 100;

      $("#highPriceFilter").attr("value", maxRangeValue);
      $("#highPriceFilter").val(maxRangeValue);
      to = maxRangeValue;
      from = 0;
      updateValues();
      updateRange();
      $(".irs-from, .irs-to").append(" €");
      window.history.replaceState({ path: link }, "", link);

      countFilterActive = 0;
      $(".count-filter--container").addClass("hide");

      $.ajax({
        type: "GET",
        url: link + "&view=filtered",
        success: function success(content) {
          var count = parseInt(content.substring(0, 4));
          $(".filter-count").text(count);
          $(
            "#collection__list--container, .collection-remove--container",
          ).remove();
          $("#collection__page--desktop").append(content.substring(4));

          clearFilter();
        },
        error: function error(_error3) {
          console.log("erreur");
        },
      });
    });
  }
  ("use strict");

  // Ouvrir la modal au clic
  $("body").on("click", ".button__action", function (e) {
    e.preventDefault();
    var buttonFor = $(this).attr("for");
    var selector = $(this).attr("open-selector");

    if (selector) {
      $(selector).addClass("opened");
      $("#page__overlay").addClass("opened");
    }

    if (buttonFor == "drawer" && selector) {
      $("#page__overlay").attr("for", "drawer");
    } else if (buttonFor == "drawer-cart" && selector) {
      $("#page__overlay").attr("for", "drawer");
      setTimeout(function () {
        $("#drawer__cart--exta-infos").addClass("opened");
      }, 350);
    } else if (buttonFor == "accordeon") {
      var isActive = false;
      if ($(this).hasClass("active")) {
        isActive = true;
      }
      if ($(this).hasClass("link--item-button")) {
        $(".link--item-button.active")
          .siblings(".accordeon__list")
          .removeClass("opened")
          .slideToggle("500");
        $(".link--item-button.active")
          .children(".plus__icon")
          .removeClass("opened");
        $(".link--item-button.active").removeClass("active");
      } else if ($(this).hasClass("sub__link--item-button")) {
        $(".sub__link--item-button.active")
          .siblings(".accordeon__list")
          .removeClass("opened")
          .slideToggle("500");
        $(".sub__link--item-button.active")
          .children(".plus__icon")
          .removeClass("opened");
        $(".sub__link--item-button.active").removeClass("active");
      }

      if (isActive == false) {
        $(this).toggleClass("active");
        $(this).children(".plus__icon").toggleClass("opened");
        $(this)
          .siblings(".accordeon__list")
          .addClass("opened")
          .slideToggle("500");
      }
    } else if (buttonFor == "modal" && selector) {
      $("#page__overlay").attr("for", "modal");
    }
  });

  // Fermer la modal au clic sur la croix
  $("body").on("click", ".close", function (e) {
    e.preventDefault();
    var closeFor = $(this).attr("for");

    $("#page__overlay").removeClass("opened");
    $("#page__overlay").attr("for", "");

    if (closeFor == "drawer") {
      $(".drawer").removeClass("opened");
    } else if (closeFor == "modal") {
      $(".modal").removeClass("opened");
      $(".modal-loader").show();
      $(".modal-has-to-load").hide();
    }
  });

  // Clic en dehors de la'modal'
  $("#page__overlay").on("click", function (e) {
    e.preventDefault();
    var overlayFor = $(this).attr("for");

    $(this).removeClass("opened");
    $("#page__overlay").attr("for", "");

    if (overlayFor == "drawer") {
      $(".drawer").removeClass("opened");
    } else if (overlayFor == "modal") {
      $(".modal").removeClass("opened");
      $(".modal-loader").show();
      $(".modal-has-to-load").hide();
    }
  });
  ("use strict");

  $("body").on(
    "click",
    ".select__custom--selected-value-container",
    function (e) {
      var forSelect = $(this).attr("for");

      $('.select__custom--values[for="' + forSelect + '"]')
        .fadeToggle(50)
        .addClass("opened");
      $('.select__custom--values:not([for="' + forSelect + '"])')
        .hide()
        .removeClass("opened");

      $(this).children(".icon--arrow-bottom").toggleClass("opened");
      $(
        '.select__custom--selected-value-container:not([for="' +
          forSelect +
          '"])',
      )
        .children(".icon--arrow-bottom")
        .removeClass("opened");
    },
  );

  $("body").on("click", ".select__custom--value", function (e) {
    var forSelect = $(this).attr("for");
    var value = $(this).attr("value");
    var valueText = $(this).text();

    $('.select__custom--value[for="' + forSelect + '"]')
      .removeClass("bg-primary text-white")
      .addClass("text-primary");
    $(this).removeClass("text-primary").addClass("bg-primary text-white");
    if (forSelect == "sort--by") {
      $('.select__custom--value[for="' + forSelect + '"]').removeClass(
        "is__active",
      );
      $(this).addClass("is__active");
    }
    $(".select__custom--selected-value-container")
      .children(".icon--arrow-bottom")
      .removeClass("opened");
    $('.select__custom--selected-value[name="' + forSelect + '"]').text(
      valueText,
    );
    $('.select__hidden[for="' + forSelect + '"]')
      .val(value)
      .trigger("change");
    $(".select__custom--values").hide().removeClass("opened");
    document.dispatchEvent(new CustomEvent("select-changed:product__option"));
  });

  $(document).on("click", function (e) {
    var product = $(".select__custom--values");
    var product2 = $(".click-select");
    if (product.is(e.target) || product2.is(e.target)) {
    } else {
      if (product.hasClass("opened")) {
        $(product).hide().removeClass("opened");
        $(".select__custom--selected-value-container")
          .children(".icon--arrow-bottom")
          .removeClass("opened");
      }
    }
  });

  Shopify.queryParams = {};
  if (location.search.length) {
    for (
      var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
      i < aCouples.length;
      i++
    ) {
      aKeyValue = aCouples[i].split("=");
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
          decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  $('.select__hidden[for="sort--by"]').bind("change", function () {
    console.log("passe sort by");
    Shopify.queryParams.sort_by = $(this).val();
    var filteredUrl = window.location.href;

    var url = new window.URL(window.location.href);
    url.searchParams.set("sort_by", Shopify.queryParams.sort_by);
    console.log(url.toString());

    filteredUrl = url.toString().replace("%2C", ",");

    if (history.replaceState) {
      window.history.replaceState({ path: filteredUrl }, "", filteredUrl);
    }

    $.ajax({
      type: "GET",
      url: filteredUrl + "&view=filtered",
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $(".filter-count").text(count);
        $("#collection__list--container").remove();
        $("#collection__page--desktop").append(content.substring(4));

        //clearFilter()
      },
      error: function error(_error) {
        console.log("erreur");
      },
    });
  });
  ("use strict");

  var prevArrow =
    '<svg class="slick-arrow--left absolute top-[50%] translate-y-[-50%] w-[58px] h-[58px] md:w-[40px] md:h-[40px] bg-white rounded-full p-[21px] md:p-[12px] left-[30px] 3xl:left-[30px] 2xl:left-[10px] z-[2] cursor-pointer rotate-180 md:border-2 md:border-primary" width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M1.65083 14L1.53754e-07 12.3498L5.44775 6.99767L-7.81626e-07 1.65025L1.65083 -3.33045e-07L8.75 6.99767L1.65083 14Z" fill="#004A36"/>\n  </svg>';
  var nextArrow =
    '<svg class="slick-arrow--right absolute top-[50%] translate-y-[-50%] w-[58px] h-[58px] md:w-[40px] md:h-[40px] bg-white rounded-full p-[21px] md:p-[12px] right-[30px] 3xl:right-[30px] 2xl:right-[10px] z-[2] cursor-pointer md:border-2 md:border-primary" width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M1.65083 14L1.53754e-07 12.3498L5.44775 6.99767L-7.81626e-07 1.65025L1.65083 -3.33045e-07L8.75 6.99767L1.65083 14Z" fill="#004A36"/>\n  </svg>';

  var prevArrowTransparent =
    '<svg class="slick-arrow--left absolute top-[50%] translate-y-[-50%] w-[58px] h-[58px] md:w-[40px] md:h-[40px] md:bg-white border border-2 border-primary rounded-full p-[19px] md:p-[12px] left-[-29px] 3xl:left-[-29px] 2xl:left-[10px] z-[2] cursor-pointer rotate-180" width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M1.65083 14L1.53754e-07 12.3498L5.44775 6.99767L-7.81626e-07 1.65025L1.65083 -3.33045e-07L8.75 6.99767L1.65083 14Z" fill="#004A36"/>\n  </svg>';
  var nextArrowTransparent =
    '<svg class="slick-arrow--right absolute top-[50%] translate-y-[-50%] w-[58px] h-[58px] md:w-[40px] md:h-[40px] md:bg-white  border border-2 border-primary rounded-full p-[19px] md:p-[12px] right-[-29px] 3xl:right-[-29px] 2xl:right-[10px] z-[2] cursor-pointer" width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M1.65083 14L1.53754e-07 12.3498L5.44775 6.99767L-7.81626e-07 1.65025L1.65083 -3.33045e-07L8.75 6.99767L1.65083 14Z" fill="#004A36"/>\n  </svg>';

  var prevArrowThumb =
    '<svg class="slick-arrow--left absolute top-[50%] translate-y-[-50%] w-[50px] h-[50px] md:w-[40px] md:h-[40px] md:bg-white rounded-full p-[18px] md:p-[12px] left-[0] 3xl:left-[-29px] 2xl:left-[10px] z-[2] cursor-pointer rotate-180" width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M1.65083 14L1.53754e-07 12.3498L5.44775 6.99767L-7.81626e-07 1.65025L1.65083 -3.33045e-07L8.75 6.99767L1.65083 14Z" fill="#004A36"/>\n  </svg>';
  var nextArrowThumb =
    '<svg class="slick-arrow--right absolute top-[50%] translate-y-[-50%] w-[50px] h-[50px] md:w-[40px] md:h-[40px] md:bg-white rounded-full p-[18px] md:p-[12px] right-[0] 3xl:right-[-29px] 2xl:right-[10px] z-[2] cursor-pointer" width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M1.65083 14L1.53754e-07 12.3498L5.44775 6.99767L-7.81626e-07 1.65025L1.65083 -3.33045e-07L8.75 6.99767L1.65083 14Z" fill="#004A36"/>\n  </svg>';

  var initSlick = function initSlick() {
    $(".background-slider").slick({
      dots: true,
      customPaging: function customPaging(slider, i) {
        return '<button class="tab"></button>';
      },
      infinite: false,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            arrows: false,
          },
        },
      ],
    });

    $(".announcement-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 1000,
      dots: false,
      infinite: true,
      arrows: false,
    });

    $(".slider-square").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: false,
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: prevArrowTransparent,
      nextArrow: nextArrowTransparent,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 1,
            variableWidth: true,
          },
        },
      ],
    });

    $(".slider-infinite").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      variableWidth: true,
    });

    $(".slider-logo").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: false,
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: prevArrowTransparent,
      nextArrow: nextArrowTransparent,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 4,
            arrows: false,
            autoplay: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            arrows: false,
            autoplay: true,
          },
        },
      ],
    });

    $(".slider-avis").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: prevArrowTransparent,
      nextArrow: nextArrowTransparent,
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $("#bandeau--footer-slider").slick({
      dots: false,
      infinite: true,
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 2,
            autoplay: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            autoplay: true,
            dots: true,
            customPaging: function customPaging(slider, i) {
              return '<button class="tab"></button>';
            },
          },
        },
      ],
    });

    $("#instagram-feed").slick({
      dots: false,
      infinite: false,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });

    $(".four-product-slider").slick({
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: prevArrowTransparent,
      nextArrow: nextArrowTransparent,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: true,
          },
        },
      ],
    });

    $(".article-slider").slick({
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: true,
          },
        },
      ],
    });

    $(".slider-info-product, .slider-cart").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 1000,
      dots: true,
      customPaging: function customPaging(slider, i) {
        return '<button class="tab"></button>';
      },
      infinite: true,
      arrows: false,
    });

    $(".product-reco--product").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: false,
      dots: false,
      infinite: false,
      arrows: true,
      prevArrow: prevArrowTransparent,
      nextArrow: nextArrowTransparent,
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  };

  initSlick();

  document.addEventListener(
    "theme-editor--slick",
    function (e) {
      $(".background-slider").filter(".slick-initialized").slick("unslick");
      $(".carousel-product-list").filter(".slick-initialized").slick("unslick");
      $(".blog-slider").filter(".slick-initialized").slick("unslick");
      $("#instagram-feed").filter(".slick-initialized").slick("unslick");
      $("#bandeau--footer-slider")
        .filter(".slick-initialized")
        .slick("unslick");

      initSlick();
    },
    false,
  );

  $(window).on("load", function () {
    $("#announcement--container .text-slide").css("opacity", "1");
  });
  ("use strict");

  $("body").on("click", ".atc", function () {
    console.log("click atc");
    var attribute = $(this).attr("data-atc");
    if (event.ctrlKey || $(this).hasClass("atc_blank")) {
      var newWindow = window.open(
        decodeURIComponent(window.atob(attribute)),
        "_blank",
      );
      newWindow.focus();
    } else {
      document.location.href = decodeURIComponent(window.atob(attribute));
    }
  });
  ("use strict");

  // Si le client veut la formule RGPD
  // --> on supprime ce qui est non commente
  // --> on decommente le reste

  $(".button--cookie").click(function () {
    $("#cookie--banner").hide();
    $("#page__overlay--cookie").removeClass("opened");
  });

  function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }

  if (getCookie("cookies-accepted") == "yes") {
  } else {
    $("#cookie--banner").addClass("apparition--cookie");
    $("#page__overlay--cookie").addClass("opened");
  }

  $("#accept--all, #reject--all").on("click", function () {
    var CookieDate = new Date();
    CookieDate.setMonth(CookieDate.getMonth() + 12);
    document.cookie =
      "cookies-accepted=yes; expires=" + CookieDate.toGMTString() + "; path=/";
  });
  /*
const observer = new MutationObserver(e => {
  e.forEach(({ addedNodes: e }) => {
    e.forEach(e => {
      //console.log(e)
      if (1 === e.nodeType && "SCRIPT" === e.tagName) {
        e.innerHTML = e.innerHTML.replace("if(window.attachEvent)", "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)").replaceAll(", asyncLoad", ", function(){}");
        if (e.innerHTML.includes("PreviewBarInjector")) {
          e.innerHTML = e.innerHTML.replace("DOMContentLoaded", "asyncLazyLoad");
        }
        if (e.className == 'analytics') {
          e.type = 'text/lazyload';
        }
        if (e.src.includes("assets/storefront/features") || e.src.includes("assets/shopify_pay") || e.src.includes("connect.facebook.net")) {
          e.setAttribute("data-src", e.src);
          e.removeAttribute("src");
        }
      }
    })
  })
});
observer.observe(document.documentElement, { childList: true, subtree: true });*/
  ("use strict");
  ("use strict");

  $(".button__with__loading").on("click", function () {
    $(this).children(".text--loading").hide();
    $(this).children(".button--loading").css("display", "flex");
  });

  function deferSrcImages(className) {
    var imgDefer = document.getElementsByClassName(className);
    for (var i = 0; i < imgDefer.length; i++) {
      if (imgDefer[i].getAttribute("defer-src")) {
        imgDefer[i].setAttribute("src", imgDefer[i].getAttribute("defer-src"));
      }
    }
  }

  window.onload = function () {
    document.dispatchEvent(new CustomEvent("update-reco-drawer"));

    setTimeout(function () {
      deferSrcImages("defer--product");
    }, 200);

    setTimeout(function () {
      $(
        '.triple-collection-home--container .slider-triple-collection[collection="collection-2"], .triple-collection-home--container .slider-triple-collection[collection="collection-3"]',
      ).css("display", "none");
    }, 200);

    if (document.referrer == "https://golf-des-marques.myshopify.com/cart") {
      $(".button__action--cart-preview").click();
    }
  };

  $(".title-collection").on("click", function () {
    var option = $(this).attr("collection");

    if ($(this).hasClass("text-primary")) {
    } else {
      $(".title-collection")
        .removeClass("text-primary")
        .addClass("text-primaryLight");
      $(this).removeClass("text-primaryLight").addClass("text-primary");
    }
    $(".slider-triple-collection").hide();
    $('.slider-triple-collection[collection="' + option + '"]').css(
      "display",
      "block",
    );
  });

  $(".search-click-doofinder").on("click", function () {
    $(".searchProduct").click();
  });

  $(".filter-button-collection").on("click", function () {
    $("#smile-ui-container").hide();
  });

  $(".filter-close-collection").on("click", function () {
    $("#smile-ui-container").show();
  });
  ("use strict");

  $("#go-top").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      500,
    );
  });

  if ($(document).scrollTop() > 20) {
    $("#go-top").show();
  } else {
    $("#go-top").hide();
  }

  $(document).on("scroll", function () {
    if ($(document).scrollTop() > 20) {
      $("#go-top").show();
    } else {
      $("#go-top").hide();
    }
  });
  ("use strict");

  var displayPrice = function displayPrice(price) {
    return price / 100 + "€";
  };
  ("use strict");

  $(".newsletter-form").submit(function (e) {
    e.preventDefault();
    if ($("#checkbox--newsletter").hasClass("checked")) {
      $(".checkbox--email").hide();

      var index = $(this).attr("form-index");
      var email = $('.email--newsletter[form-index="' + index + '"]')
        .val()
        .toLowerCase();
      var fields = "$source,$email,$consent";

      var formData = {
        email: email,
        g: $('.list--newsletter[form-index="' + index + '"]').val(), // liste klaviyo
        $consent: "email",
        $source: $('.newsletter-form[form-index="' + index + '"]').attr(
          "source",
        ),
        $fields: fields,
      };

      $.ajax({
        type: "POST",
        url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        data: formData,
        dataType: "json",
        success: function success(response) {
          if (response.errors && response.errors.length > 0) {
            $(".newsletter-form .error--email").show();
            _learnq.push([
              "identify",
              {
                $email: email,
              },
            ]);
          } else {
            $(".newsletter-form .success--email").show();
          }
        },
        error: function error(_error) {
          $(".newsletter-form .error--email").show();
        },
      });
    } else {
      $(".checkbox--email").show();
    }
  });

  $(".checkbox-newsletter").on("click", function () {
    if ($(this).children("#checkbox--newsletter").hasClass("checked")) {
      $(this)
        .children("#checkbox--newsletter")
        .removeClass("checked bg-primary")
        .addClass("bg-white");
    } else {
      $(this)
        .children("#checkbox--newsletter")
        .addClass("checked bg-primary")
        .removeClass("bg-white");
    }
  });
  ("use strict");

  if (window.matchMedia("(max-width: 767px)").matches) {
    $("#sidebar-accordion-footer .plus__icon").show();
    $("#sidebar-accordion-footer")
      .find("li.extend")
      .click(function (e) {
        $(this)
          .children(".extended-submenu")
          .slideToggle("fast")
          .css("display", "flex");
        $(this)
          .children(".nav__footer--title")
          .children(".plus__icon")
          .toggleClass("opened");
        $(this).toggleClass("active");
      });
  }

  $(window).on("resize", function () {
    if (window.matchMedia("(max-width: 767px)").matches) {
      $("#sidebar-accordion-footer .extended-submenu").hide();
    }
    if (window.matchMedia("(min-width: 768px)").matches) {
      $("#sidebar-accordion-footer .extended-submenu").show();
    }
  });
  ("use strict");

  var pageOverlayOpened = false;
  $(".navigation__item--link-megamenu").mouseenter(function () {
    if (pageOverlayOpened == false) {
      $("#page__overlay--navigation").addClass("opened");
      pageOverlayOpened = true;
    }
  });

  $(".navigation__item--link-megamenu").mouseleave(function () {
    if (pageOverlayOpened == true) {
      $("#page__overlay--navigation").removeClass("opened");
      pageOverlayOpened = false;
    }
  });

  // Gestion de la hauteur du drawer sur mobile
  // a utiliser si le drawer ne fait pas 100% de l'ecran, sinon on peut commenter
  if ($(document).scrollTop() > 20) {
    var navbarHeightMobile = 40;
  } else {
    var navbarHeightMobile = 74;
  }
  $("#navigation__drawer, #cart__drawer").css("height", window.innerHeight); // init
  $(document).on("scroll", function () {
    if ($(document).scrollTop() > 20) {
      var navbarHeightMobile = 40;
    } else {
      var navbarHeightMobile = 74;
    }
    $("#navigation__drawer, #cart__drawer").css("height", window.innerHeight);
  });

  if (window.matchMedia("(min-width: 1101px)").matches) {
    $(document).on("scroll", function () {
      if ($(document).scrollTop() > 20) {
        //$('.logo-nav').attr('src', window.nav.logoScroll)
        //$('.top--container').removeClass('py-[5px]').addClass('py-[15px]')
        //$('.image-back-nav').addClass('hidden')
      } else {
        //$('.logo-nav').attr('src', window.nav.logoNoScroll)
        //$('.top--container').addClass('py-[5px]').removeClass('py-[15px]')
        //$('.image-back-nav').removeClass('hidden')
      }
    });
  }
  /*
if (window.location.href.indexOf("blog") > -1 || window.location.href.indexOf("article") > -1) {
  $('#icon-search-blog, #icon-search-blog-2').on('click', function(){
    if ($('.search--container').hasClass('opened-blog')) {
      $('.search--container').removeClass('opened-blog');
      $('.searchArticle').val('');
      $(".result-search").html('');
    } else {
      $('.search--container').addClass('opened-blog');
    }
  })

  var handleCloseSearch = function() {
    $('.searchArticle').val('');
    $(".result-search").html('');
    $('.search--container').removeClass('opened-blog');
    $('.search--container').css('transform', '');
  }

  $('.close--search').on('click', function(){
    handleCloseSearch();
  })

  $(document).on('click', function(e){

    var container = $(".search--container");
    var container2 = $(".search--container-barre");
    if ($(e.target).hasClass('search--trigger')) {
    } else {
      if (container.hasClass('opened-blog') && !container.is(e.target) && container.has(e.target).length === 0) {
        handleCloseSearch()
      }
    }

    if (!container2.is(e.target) && container2.has(e.target).length === 0) {
      $('.searchArticle-barre').val('');
      $('.result-search-barre').html('');
    }
  });
} else {
  var handleSearchBar = function(searchTriggerId, positionScrolledClass, positionClass, translateYScrolled, translateY) {
    $(searchTriggerId).on('click', function(){
      if ($('.search--container').hasClass(positionScrolledClass) || $('.search--container').hasClass(positionClass)) {
        $('#page__overlay--navigation').removeClass('opened');
        $('.navigation__item--container').removeClass('search--opened');
        $('#navigation--container').removeClass('fixedWhiteNav');
        $('.search--container').removeClass(`${positionScrolledClass} ${positionClass}`).css('transform', '');
        $('.searchProduct').val('');
        $(".result-search").html('');
        $(".popular_product").removeClass('opened');
      } else {
        $('#page__overlay--navigation').addClass('opened');
        $('#navigation--container').addClass('fixedWhiteNav').removeClass('transparent--nav');
        $(".popular_product").addClass('opened');
        if ($(document).scrollTop() >= 20) {
          $('.search--container').addClass(positionScrolledClass);
          $(`.search--container.${positionClass}, .search--container.${positionScrolledClass}`).css('transform', `translateY(${translateYScrolled}px)`);
        } else {
          var topPosition = translateY - $(document).scrollTop();
          $('.search--container').addClass(positionClass);
          $(`.search--container.${positionClass}, .search--container.${positionScrolledClass}`).css('transform', `translateY(${topPosition}px)`);
        }
      }
      $('.searchProduct.search--input').focus()
    })

    $(document).on('scroll', function() {
      if ( $(document).scrollTop() >= 20 ) {
        $(`.search--container.${positionClass}, .search--container.${positionScrolledClass}`).css('transform', `translateY(${translateYScrolled}px)`);
      } else {
        var topPosition = translateY - $(document).scrollTop();
        $(`.search--container.${positionClass}, .search--container.${positionScrolledClass}`).css('transform', `translateY(${topPosition}px)`);
      }
    });
  }

  if (window.matchMedia("(max-width: 767px)" ).matches){
    handleSearchBar('#icon-search', 'opened-mobile-scroll', 'opened-mobile2', 265, 305);
  } else if (window.matchMedia("(max-width: 1100px)" ).matches) {
    handleSearchBar('#icon-search', 'opened-mobile-scroll', 'opened-mobile', 265, 305);
  } else {
    handleSearchBar('#icon-search', 'opened-scroll', 'opened', 288, 328);
  }

  var handleCloseSearch = function() {
    $('.searchProduct').val('');
    $(".result-search").html('');
    $('.search--container').removeClass('opened opened-scroll opened-mobile-scroll opened-mobile opened-mobile2').css('transform', '');
    $('#navigation--container').removeClass('fixedWhiteNav');
    $('#page__overlay--navigation').removeClass('opened');
    $('.navigation__item--container').removeClass('search--opened');
    $('.popular_product').removeClass('opened')
  }

  $('.close--search').on('click', function(){
    handleCloseSearch();
  })

  $(document).on('click', function(e){
    var container = $(".search--container");
    if ($(e.target).hasClass('search--trigger')) {
    } else {
      if ((container.hasClass('opened') || container.hasClass('opened-mobile') || container.hasClass('opened-mobile2')) && !container.is(e.target) && container.has(e.target).length === 0) {
        handleCloseSearch()
      }
    }
  });

  $(document).on('click', '.global-search', function(){
    //var url = window.location.hostname
    var search = document.getElementsByClassName('searchProduct')[0].value;
    var redirection = "/search?type=product&q=" + search;
    window.location.replace(redirection);
    $('.search--container').removeClass('opened');
  })
}


$(document).on('input', '.search--input', function() {
  if ($(this).attr('search') === 'barre') {
    SearchFunction('searchArticle-barre', 'article', 'result-search-barre')
  } else if ($(this).attr('search') === 'article'){
    SearchFunction('searchArticle', 'article', 'result-search')
  } else if ($(this).attr('search') === 'produit'){
    SearchFunction('searchProduct', 'product', 'result-search')

  }
});

var SearchFunction = function(classInput, typeSearch, classInputResult){

  var htmlItem = function(type, item, index) {
    if (type == "article") {
      return "<div class='one-product'><a class='flex fd--row jc--flex-start' href=" + item[index].url + "><img class='image-product' src=" + item[index].image + "><div class='content--container flex fd--column ai--flex-start'><p class='price--grid dark__color'>" + item[index].title + "</p></div></a></div>"
    } else {
      if (item[index].compare_at_price_max == 0.00) {
        var prix = item[index].price.replace('.', ',') +'€';
      } else {
        var prix = item[index].price.replace('.', ',') + "€<span class='line-through mx-[10px] mr-0'>" + item[index].compare_at_price_max.replace('.', ',') + "€</span>"
      }
      return " <div class='one-product'><a class='flex flex-col' href=" + item[index].url + "><img class='w-full h-auto object-cover' src=" + item[index].image + "><div class='flex flex-col my-[10px] mb-0'><p class='body--text'>" + item[index].title + "</p><p class='price body--text'>" + prix + "</p></div></a></div>"
    }
  }

  var emptyItem = function(type){
    if (type == "article") {
      return "<div class='empty'>Aucun article ne correspond à votre recherche</div>"
    } else {
      return "<div class='empty px-[20px] py-[10px] text-center col-start-1 col-end-5 2xl:col-end-3'>Aucun produit ne correspond à votre recherche</div>"
    }
  }

  var q = document.getElementsByClassName(classInput)[0].value;
  var b = `&resources[type]=${typeSearch}`
  var c = '';
  if (q == "") {
    $(".result-search").html('');
    $(".result-search-barre").html('');
  }
  if (typeSearch == 'article') {
    var type = "article"
  } else {
    var type = "product"
    c = '&fields=title,product_type,tag';
    if (q == "") {
      $(".popular_product").addClass('opened');
    } else {
      $(".popular_product").removeClass('opened');
    }
  }
  $.ajax('/search/suggest.json?q=' + q + b + c,{
    type: 'GET',
    dataType: 'json',
    success: function(response) {
      var itemsSuggestions = response.resources.results[`${typeSearch}s`];
      if (itemsSuggestions.length > 0) {
        var result = ""
        for (var i = 0; i < itemsSuggestions.length; i++) {
          if (itemsSuggestions[i].id != 6623214993579 && itemsSuggestions[i].id != 6623216205995) {
            result += htmlItem(type, itemsSuggestions, i);
          }
        }

        if (type == "product") {
          result = result + "<div class='global-search col-start-1 col-end-5 ml-[-20px] w-[calc(100%+40px)] sticky bottom-0 left-0 px-[20px] py-[10px] bg-secondary cursor-pointer body--text text-center 2xl:col-end-3'>Plus de résultats</div>";
        }
        $(`.${classInputResult}`).html(result);
      } else {
        var emptyProduct = emptyItem(type)
        $(`.${classInputResult}`).html(emptyProduct);
      }
    }
  });
}
*/
  ("use strict");
  ("use strict");

  $(".faq-question--container").on("click", function () {
    var $question = $(this).children(".faq__question");
    $(".plus__icon").removeClass("opened");
    $question.children(".plus__icon").toggleClass("opened");
    if ($question.next().attr("aria-hidden") == "false") {
      $question.next().slideToggle(200).attr("aria-hidden", "true");
      $(".plus__icon").removeClass("opened");
    } else {
      $(".faq-question--container")
        .find('.faq__answer[aria-hidden="false"]')
        .not($question)
        .slideToggle(200)
        .attr("aria-hidden", "true");
      $question.next().slideToggle(200).attr("aria-hidden", "false");
    }
  });

  $(".faq-link").on("click", function () {
    var block = $(this).attr("link");
    $("html, body").animate(
      {
        scrollTop: $(block).offset().top - 220,
      },
      500,
    );
  });
  ("use strict");

  if (window.general.photoSwipe == true) {
    var container = [];

    $("#slider--product")
      .find(".carousel-cell")
      .each(function () {
        var $link = $(this).find(".product__image"),
          item = {
            src: $link.attr("src"),
            w: $link.attr("width"),
            h: $link.attr("height"),
          };
        console.log(item);
        container.push(item);
      });

    var gallery = "";
    // Define click event on gallery item
    $("body").on("click", "#slider--product .carousel-cell", function (event) {
      // Prevent location change
      event.preventDefault();

      // Define object and gallery options
      var $pswp = $(".pswp")[0],
        options = {
          index: $(this).index(),
        };
      console.log($(this));

      // Initialize PhotoSwipe
      gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, container, options);
      gallery.init();

      if (window.matchMedia("(max-width: 1000px)").matches) {
        $("#slider--product")
          .find(".carousel-cell")
          .each(function () {
            var id = $(this).attr("id");
            if (id !== undefined) {
              console.log(id);
              console.log($(this));
              $(this)
                .find(".product__image")
                .clone()
                .appendTo(".pswp__thumbnail");
            }
          });
      } else {
        $("#slider--product img").clone().appendTo(".pswp__thumbnail");
      }

      $(".button-pswp--container, .pswp__thumbnail").addClass("opened");

      $(".pswp__thumbnail img")
        .eq(gallery.getCurrentIndex())
        .addClass("active");

      gallery.listen("close", function () {
        $(".pswp__thumbnail img").remove();
        $(".button-pswp--container, .pswp__thumbnail").removeClass("opened");
      });
    });

    $("body").on("click", ".pswp__thumbnail img", function (e) {
      $(".pswp__thumbnail img").removeClass("active");
      $(this).addClass("active");

      var number = $(".pswp__thumbnail img").index($(this));
      console.log(number);
      console.log(gallery);
      gallery.goTo(number);

      $(".button-zoom-pswp").children(".see-more").removeClass("opened");
    });

    $("body").on("click", ".button-close-pswp", function () {
      gallery.close();
    });

    $("body").on("click", ".button-zoom-pswp", function () {
      gallery.toggleDesktopZoom();
      if ($(".pswp").hasClass("pswp--zoomed-in")) {
        $(".button-zoom-pswp").children(".see-more").addClass("opened");
      } else {
        $(".button-zoom-pswp").children(".see-more").removeClass("opened");
      }
    });

    $("body").on("click", ".pswp__img", function () {
      if ($(".pswp").hasClass("pswp--zoomed-in")) {
        $(".button-zoom-pswp").children(".see-more").addClass("opened");
      } else {
        $(".button-zoom-pswp").children(".see-more").removeClass("opened");
      }
    });
  }
  ("use strict");

  $("#slider--product").slick({
    dots: false,
    infinite: false,
    arrows: false,
    waitForAnimate: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    asNavFor: "#slider__nav--product",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
        },
      },
    ],
  });

  $("#slider--product2").slick({
    dots: false,
    infinite: false,
    arrows: false,
    waitForAnimate: false,
    slidesToScroll: 1,
    slidesToShow: 1,
  });

  $("#slider__nav--product").slick({
    dots: false,
    infinite: false,
    arrows: true,
    prevArrow: prevArrowThumb,
    nextArrow: nextArrowThumb,
    waitForAnimate: false,
    slidesToScroll: 1,
    slidesToShow: 4,
    asNavFor: "#slider--product",
  });

  $("#slider__nav--product2").slick({
    dots: false,
    infinite: false,
    arrows: true,
    prevArrow: prevArrowThumb,
    nextArrow: nextArrowThumb,
    waitForAnimate: false,
    slidesToScroll: 1,
    slidesToShow: 4,
  });

  $("#slider__nav--product2 .thumb--image").on("click", function () {
    var index = $(this).attr("thumb-index");
    $("#slider--product2").slick("slickGoTo", index);
  });

  $("#slider__nav--product .thumb--image").on("click", function () {
    var index = $(this).attr("thumb-index");
    $("#slider--product").slick("slickGoTo", index);
  });
  ("use strict");

  var productDetails = {};
  if ($("[product-details]").html()) {
    productDetails = JSON.parse($("[product-details]").html());
  }

  document.addEventListener(
    "select-changed:product__option",
    function (event) {
      onOptionChanged();
    },
    false,
  );

  function updateProductButton(variant, productId) {
    let hasPrecoTag = false;

    //console.log(variant.productHandle);
    // fetch data about product tags to check if product has specific tag (preco)

    fetch(
      window.Shopify.routes.root + "products/" + variant.productHandle + ".js",
    )
      .then((response) => response.json())
      .then((product) => {
        //teste si le produit à un tag particulier (ici preco)
        if (product.tags.indexOf("preco") !== -1) {
          hasPrecoTag = true;
        }

        //console.log("condition : " + !hasPrecoTag);

        if (!hasPrecoTag) {
          if (
            variant.sellWithRupture == "continue" &&
            variant.availableQty <= 0
          ) {
            var texte;
            if (variant.textWithRupture != "") {
              texte =
                '<p class="px-[15px] pr-0 product--subtitle text-primaryLight3 border-l border-primaryLight3">' +
                variant.textWithRupture +
                "</p>";
            }
            $(".available-form--container")
              .removeClass("hidden")
              .html(
                '<p class="product--subtitle text-primaryLight3 font-bold ' +
                  (variant.textWithRupture != "" ? "px-[15px] pl-0" : "") +
                  '">Sur commande</p>' +
                  (variant.textWithRupture != "" ? texte : ""),
              );
          } else if (variant.available == 0) {
            $(".available-form--container").addClass("hidden");
          } else {
            $(".available-form--container")
              .removeClass("hidden")
              .html(
                '<p class="product--subtitle text-primaryLight3 font-bold px-[15px] pl-0 border-r border-primaryLight3">En stock</p>\n      <p class="px-[15px] pr-0 product--subtitle text-primaryLight3">Exp\xE9di\xE9 sous 24/48h</p>',
              );
          }
        }

        //console.log(productId.productHandle);
        //console.log(productId);
        if (hasPrecoTag) {
          $('.add__to__cart[product-id="' + productId + '"]')
            .html("Précommander")
            .show();
        } else if (variant.available == 0) {
          $('.add__to__cart[product-id="' + productId + '"]')
            .html("Rupture de stock")
            .hide();
        } else {
          $('.add__to__cart[product-id="' + productId + '"]')
            .html("Ajouter au panier")
            .show();
        }
      });
  }

  function onOptionChanged() {
    var productOptions = [];

    for (var i = 1; i <= 3; i++) {
      productOptions[i - 1] =
        $(
          '.select__custom--selected-value[product-id="' +
            productDetails.productId +
            '"][name="product__option--' +
            i +
            '"]',
        )
          .text()
          .trim() || "";
    }
    console.log(productOptions);
    console.log(productDetails);
    if (productDetails && productDetails.variants.length > 1) {
      productDetails.variants.forEach(function (variant) {
        if (
          variant.option1 == productOptions[0] &&
          variant.option2 == productOptions[1] &&
          variant.option3 == productOptions[2]
        ) {
          var priceSplit = variant.price.split(",");
          $(".price-js-first").html(
            priceSplit[0] +
              '  <span class="absolute text-[12px] right-[-9px] top-[5px] font-bold md:top-[-1px]">\u20AC</span>',
          );
          $(".price-js-second").text(priceSplit[1]);

          var compareSplit = variant.compareAtPrice.split(",");
          $(".compare-js-first").html(
            compareSplit[0] +
              '  <span class="absolute text-[12px] right-[-9px] top-[5px] font-bold md:top-[-1px]">\u20AC</span>',
          );
          $(".compare-js-second").text(compareSplit[1]);

          $(".compare-price-js").text(variant.compareAtPrice);

          var pourcentage = Math.round(
            (1 -
              parseInt(variant.priceWithout) /
                parseInt(variant.compareAtPriceWithout)) *
              100,
          );
          if (pourcentage) {
            $(".sales__tag--container").show();
            $(".sales__tag--container .text-sales").text("-" + pourcentage);
          } else {
            $(".sales__tag--container").hide();
          }
          $(
            '.add__to__cart[product-id="' + productDetails.productId + '"]',
          ).attr("variant-id", variant.id);
          $(
            '.add__to__cart[product-id="' + productDetails.productId + '"]',
          ).attr("ref_couleur", variant.color);
          var url =
            document.location.origin +
            document.location.pathname +
            ("?variant=" + variant.id);
          window.history.replaceState({ path: url }, "", url);
          var featuredImage = variant.imageId;

          // Change image on variant change
          var imageNumber =
            parseInt(
              $(
                '#slider--product .product__image[image-id="' +
                  featuredImage +
                  '"]',
              ).attr("slide-number"),
            ) - 1;
          if (imageNumber) {
            $("#slider--product").slick("slickGoTo", imageNumber);
          }

          updateProductButton(variant, productDetails.productId);
        }
      });
    }
  }

  $(".quantity__change--selector-product").on("click", function () {
    console.log("plus");
    var type = $(this).attr("type");
    var currentQty = parseInt(
      $(".product__qty--container .quantity__current").val(),
    );

    if (type == "minus") {
      if (currentQty != 0) {
        $(".product__qty--container .quantity__current").val(currentQty - 1);
      }
    } else {
      $(".product__qty--container .quantity__current").val(currentQty + 1);
    }
  });

  $(".bulle__custom--value").on("click", function () {
    var value = $(this).attr("value");
    var option = $(this).attr("for");

    console.log(value);
    $('.select__custom--selected-value[for="' + option + '"]').text(value);
    $('.bulle__custom--value[for="' + option + '"]')
      .removeClass("bg-primary text-white")
      .addClass("text-primary bg-primaryLight2");
    $(this)
      .addClass("bg-primary text-white")
      .removeClass("text-primary bg-primaryLight2");

    document.dispatchEvent(new CustomEvent("select-changed:product__option"));
  });

  if (window.location.href.indexOf("/products/") > -1) {
    var id = productDetails.productId;
    if (id == "8575205671245") {
    } else {
      fetch(
        window.Shopify.routes.root +
          ("recommendations/products.json?product_id=" + id + "&limit=4"),
      )
        .then(function (response) {
          return response.json();
        })
        .then(function (_ref) {
          var products = _ref.products;

          var loop;
          if (products.length < 3) {
            loop = products.length - 1;
          } else {
            loop = 3;
          }
          if (products.length > 0) {
            for (var i = 0; i <= loop; i++) {
              var price = products[i].price / 100;
              var priceFinal = price.toFixed(2) + "€";
              var priceSplit = priceFinal.split(".");

              var comparePrice = products[i].compare_at_price / 100;
              if (comparePrice == 0 || comparePrice == price) {
                var comparePriceFinal = "";
              } else {
                var comparePriceFinal = comparePrice.toFixed(2) + "€";
                var compareSplit = comparePriceFinal.split(".");
              }

              console.log(products);

              var imageFour = products[i].images[0];
              var imageFinal;
              if (imageFour.includes("jpg")) {
                var imageSplit = imageFour.split(".jpg");
                imageFinal = imageSplit[0] + "_500x.jpg";
              } else if (imageFour.includes("jpeg")) {
                var imageSplit = imageFour.split(".jpeg");
                imageFinal = imageSplit[0] + "_500x.jpeg";
              } else if (imageFour.includes(".png")) {
                var imageSplit = imageFour.split(".png");
                imageFinal = imageSplit[0] + "_500x.png";
              } else {
                imageFinal = products[i].images[0];
              }

              var imageOne = products[i].images[1];
              var imageHover;
              if (products[i].images[1] == undefined) {
                imageOne = products[i].images[0];
              } else {
                imageOne = products[i].images[1];
              }
              if (imageOne != undefined) {
                if (imageOne.includes("jpg")) {
                  var imageSplit = imageOne.split(".jpg");
                  imageHover = imageSplit[0] + "_500x.jpg";
                } else if (imageOne.includes("jpeg")) {
                  var imageSplit = imageOne.split(".jpeg");
                  imageHover = imageSplit[0] + "_500x.jpeg";
                } else if (imageOne.includes(".png")) {
                  var imageSplit = imageOne.split(".png");
                  imageHover = imageSplit[0] + "_500x.png";
                } else {
                  if (products[i].images[1] == undefined) {
                    imageHover = products[i].images[0];
                  } else {
                    imageHover = products[i].images[1];
                  }
                }
              }

              var hasGridTag = false;
              var noOrderWithoutPriceGrid = false;
              var noOrderWithPriceGrid = false;
              var degressif = false;
              for (var j = 0; j < products[i].tags.length; j++) {
                if (products[i].tags[j].indexOf("grid-tag--") !== -1) {
                  hasGridTag = true;
                  break;
                } else if (
                  products[i].tags[j].indexOf(
                    "not-order-product-without-price",
                  ) !== -1
                ) {
                  noOrderWithoutPriceGrid = true;
                  break;
                } else if (
                  products[i].tags[j].indexOf(
                    "not-order-product-with-price",
                  ) !== -1
                ) {
                  noOrderWithPriceGrid = true;
                  break;
                } else if (
                  products[i].tags[j].indexOf("Prix dégressif") !== -1
                ) {
                  degressif = true;
                  break;
                }
              }

              var hasCompare = false;
              if (comparePriceFinal != "") {
                hasCompare = true;
              }

              var tag, price;
              if (hasGridTag == true) {
                tag =
                  '<p class="absolute top-[10px] left-[10px] px-[10px] py-[2px] rounded-[12px] tag--text text-white"' +
                  ' style="background-color:#' +
                  products[i].tags[j].replace("grid-tag--", "").split("-#")[1] +
                  '">' +
                  products[i].tags[j].replace("grid-tag--", "").split("-#")[0] +
                  "</p>";
              }
              if (noOrderWithoutPriceGrid == false) {
                price =
                  "<div class=\"flex flex-row justify-center items-center relative w-fit ml-auto mr-auto after:content[' '] after:w-[calc(100%+10px)] after:absolute after:h-[1px] after:bg-[#c0c0c0] after:bottom-[8px] after:z-[-1] " +
                  (hasCompare == false ? "no-compare" : "") +
                  '" >\n                ' +
                  (degressif == true
                    ? '<p class="body--text text-black mx-[5px] ml-0">A partir de </p>'
                    : "") +
                  "\n                " +
                  (hasCompare == true
                    ? '<div class="flex flex-row items-end relative after:content-[\' \'] after:h-[1px] after:bg-red after:absolute after:top-[50%] after:translate-y-[-50%] after:w-full after:rotate-[-15deg] mx-[15px] ml-0 md:mx-[10px] md:ml-0">\n                  <p class="product--price flex flex-row font-bold relative text-grayDark">' +
                      compareSplit[0] +
                      ' <span class="absolute text-[12px] right-[-9px] top-[5px] font-bold md:top-[-1px]">\u20AC</span></p>\n                  <p class="product--price-small font-bold mb-[6px] ml-[1px] text-grayDark md:mb-[4px]">' +
                      compareSplit[1] +
                      "</p>\n                </div>"
                    : "") +
                  "\n                " +
                  (hasCompare == true
                    ? '<p class=" sales__tag--container reduction--text text-white rounded-full h-[46px] w-[46px] flex items-center relative justify-center font-bold bg-primary">\n                  <span class="ml-[-4px] sales-text"></span>\n                  <span class="absolute reduction--text text-white top-[10px] right-[5px]" style="font-size: 8px">%</span>\n                </p>'
                    : "") +
                  '\n                \n                <div class="flex flex-row items-end ' +
                  (hasCompare == true
                    ? "mx-[15px] mr-0 md:mx-[10px] md:mr-0"
                    : "") +
                  '">\n                  <p class="product--price flex flex-row font-bold relative text-black">' +
                  priceSplit[0] +
                  ' <span class="absolute text-[12px] right-[-9px] top-[5px] font-bold md:top-[-1px]">\u20AC</span></p>\n                  <p class="product--price-small font-bold mb-[6px] ml-[1px] text-black md:mb-[4px]">' +
                  priceSplit[1] +
                  "</p>\n                </div>\n              </div>";
              }

              var list = "";

              if (products[i].options.length > 1) {
                for (var k = 0; k < products[i].options.length; k++) {
                  var valueList = "";
                  for (
                    var l = 0;
                    l < products[i].options[k].values.length;
                    l++
                  ) {
                    valueList =
                      valueList +
                      ' <p class="nav--text text-primary whitespace-nowrap">' +
                      products[i].options[k].values[l] +
                      "</p>" +
                      (l == products[i].options[k].values.length - 1
                        ? ""
                        : '<div class="w-[3px] h-[3px] rounded-full bg-primary mx-[5px] min-w-[3px]"></div>');
                  }
                  list =
                    list +
                    ' <div class="flex flex-row items-center max-w-full overflow-ellipsis overflow-hidden my-[5px] mt-0 last:mb-0">\n                  <p class="nav--text font-bold text-primary whitespace-nowrap mx-[5px] ml-0">' +
                    products[i].options[k].name +
                    " : </p>\n                  " +
                    valueList +
                    "\n                </div>";
                }
              }

              $(".four-product-new").append(
                '<div class="product__item--container relative h-fit product-reco' +
                  i +
                  '">\n              ' +
                  (hasGridTag == true ? tag : "") +
                  '\n              <span class="product__item__link--container z-[2] atc cursor-pointer" data-atc="' +
                  window.btoa("/products/" + products[i].handle) +
                  '">\n                <img class="lazyload product__item__image w-full" data-src="' +
                  imageFinal +
                  '" >\n                <div class="px-[20px] flex flex-col justify-between my-[20px] mb-0">\n                  <p class="flex flex-col items-center">\n                    <span class="h5--body font-bold text-black uppercase text-center">' +
                  products[i].vendor +
                  '</span>\n                    <span class="whitespace-nowrap max-w-full overflow-ellipsis overflow-hidden nav--text text-black text-center my-[10px] mt-0">' +
                  products[i].title +
                  "</span>\n                  </p>\n                  " +
                  (noOrderWithoutPriceGrid == false ? price : "") +
                  "\n                </div>\n        \n                " +
                  (products[i].available == false &&
                  noOrderWithoutPriceGrid == false &&
                  noOrderWithPriceGrid == false
                    ? '<p class="absolute body--text px-[20px] py-[10px] text-white bg-primary rounded-[10px] top-[150px] left-[50%] translate-x-[-50%] z-[90] whitespace-nowrap md:top-[75px]">Stock épuisé</p>'
                    : "") +
                  '\n   \n  \n                <div class="product__item__div--hover flex flex-col absolute  h-fit top-0 left-0 opacity-0 overflow-hidden transition-all duration-150 bg-white rounded-[10px] w-full">\n                  <img class="lazyload rounded-[10px] max-h-[350px] w-full object-contain  md:h-[200px]" data-src="' +
                  imageHover +
                  '" >\n                  ' +
                  (list != ""
                    ? '<div class="bg-primaryLight2 px-[30px] py-[10px] rounded-[10px] absolute bottom-0 left-0 w-full">\n                    ' +
                      list +
                      "\n                  </div>"
                    : "") +
                  "\n                </div>\n              </span>\n            </div>",
              );

              if (products[i].compare_at_price != null) {
                var solde =
                  (products[i].price * -100) / products[i].compare_at_price +
                  100;
                var soldeFinal = Math.floor(solde);

                $(
                  ".product-reco" + i + " .sales__tag--container .sales-text",
                ).text(soldeFinal);
              } else {
                $(".product-reco" + i + " .sales__tag--container").remove();
                $(
                  ".product-reco" + i + " .product__grid--price-compare",
                ).remove();
              }
            }

            $(".four-product-new").slick({
              dots: false,
              infinite: true,
              arrows: true,
              prevArrow: prevArrow,
              nextArrow: nextArrow,
              slidesToShow: 4,
              slidesToScroll: 1,
              responsive: [
                {
                  breakpoint: 950,
                  settings: {
                    slidesToShow: 3,
                  },
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                  },
                },
              ],
            });
          } else {
            $(".four-products-product").hide();
          }
        });
    }
  }

  $("#see-all-product").on("click", function () {
    if ($(this).hasClass("active")) {
      $(".container-overflow").addClass("lg:max-h-[175px]");
      $(this).removeClass("active").text("Voir plus");
    } else {
      $(".container-overflow").removeClass("lg:max-h-[175px]");
      $(this).addClass("active").text("Voir moins");
    }
  });

  $(".see-more-pruduct").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: $("#description-product").offset().top - 220,
      },
      500,
    );
  });

  /* Changement du trigger click au trigger change pour eviter que les gens valident leurs panier sans enregistrer le message perso*/
  /* en commentaire le code d'origine*/
  $(".register-perso-text").on(/*'click'*/ "change", function () {
    //edit

    //var text = $('.perso-text').val();          //orignal
    var text = $(this).val(); //edit
    $(this).css("border-color", "initial"); //ajout

    var id = $(this).attr("product-id");
    console.log(text);
    if (text != "") {
      $(".add__to__cart[product-id=" + id + "]").addClass("perso-text");
    } else {
      $(".add__to__cart[product-id=" + id + "]").removeClass("perso-text");
    }
  });

  $(document).ready(function () {
    if (productDetails.hasAlert == "true") {
      $("#page__overlay").attr("for", "modal").addClass("opened");
      $("#modal-alert").addClass("opened");
    }
  });

  $(".button-alert").on("click", function () {
    $("#modal-alert .close").click();
  });

  $(".button-no-order").on("click", function () {
    if ($(".text-no-order").hasClass("hidden")) {
      $(".text-no-order").removeClass("hidden");
    } else {
      $(".text-no-order").addClass("hidden");
    }
  });
});
